import { createClassName } from 'utils/createClassName';

import './paginationStyles.scss';

export const createPaginationClassName = createClassName('pagination');
